<template>

  <div class="head">
    <div class="head_user">

      <div class="username">
        <NuxtLink class="lnk av" :to="props.user.link">
          <img loading="lazy" v-if="props.user?.avatar_little" class="ava" :src="props.user.avatar_little" :alt="props.user.name">
        </NuxtLink>
        <NuxtLink class="lnk nm" :to="props.user.link">
          {{ props.user.name }}
        </NuxtLink>

        <div class="date">
          {{ $dayjs(props.week.add_date).fromNow() }}
        </div>        
      </div>


      <div class="brands" v-if="props.itemsSeed?.length" ref="elBrands">
        <template v-if="props.itemsSeed.length == 1">
          <NuxtLink :to="props.itemsSeed[0].item_brand.link" class="brand">
            <img loading="lazy" :src="props.itemsSeed[0].item_brand.logo_s" :alt="props.itemsSeed[0].item_brand.name" class="brand_logo">
          </NuxtLink>
          <NuxtLink :to="props.itemsSeed[0].link" class="nm">
            {{ props.itemsSeed[0].name }}
          </NuxtLink>
        </template>
        <template v-else>
          <NuxtLink :to="product.link" v-for="(product, index) in brandSeedUniqLogos" :key="index" class="brand">
            <img loading="lazy" :src="product.item_brand.logo_s" :alt="product.item_brand.name + ' - ' + product.name" class="brand_logo">
          </NuxtLink>
          <span class="nm">
            <template v-if="props.itemsSeed.length - brandSeedUniqLogos.length > 0">
              +{{ props.itemsSeed.length - brandSeedUniqLogos.length }} {{ $plurals.get('strain', props.itemsSeed.length - brandSeedUniqLogos.length) }}
            </template>
            <template v-else>
              +{{ props.itemsSeed.length }} {{ $plurals.get('strain', props.itemsSeed.length) }}
            </template>      
          </span>    
        </template>

        <ClientOnly>
          <UiTooltip 
            :target-el="elBrands" 
            preferred-placement="bottom" 
            :max-width="300"
            :hide-delay="300"
            :show-on-focus="true"
            :interactive="true"
            >
            <div class="tooltip-brands">
              <NuxtLink 
                v-for="(item, index) in props.itemsSeed" 
                :key="index" 
                :to="item.item_brand.link" 
                class="brand"
              >
                <img loading="lazy" :src="item.item_brand.logo_s" :alt="item.item_brand.name + ' - ' + item.name" class="lg">
                <span class="nm">
                  {{ item.item_brand.name }}
                  <template v-if="item.item_brand.name !== item.name">
                    - {{ item.name }}
                  </template>
                </span>
              </NuxtLink>
            </div>
          </UiTooltip>
        </ClientOnly>

        
      </div>

    </div>

    <NuxtLink :to="props.diary.link + '#weeks/' + props.week.id" class="diary text-ellipsis-2">
      <span @click="useDiary().modalClick($event, props.diary.id, props.diary.link + '#weeks/' + props.week.id, props.diary)">
        {{ props.diary.name }}
      </span>
    </NuxtLink>

    <div class="matches" v-if="matches">
      Based on follows
      <template v-for="(item, index) in matches" :key="index">
        <span class="nm">
          {{ item.name }}<span v-if="index !== matches.length - 1">, </span>
        </span>        
        <!-- <NuxtLink :to="item.link" class="nm">
          {{ item.name }}<span v-if="index !== matches.length - 1">, </span>
        </NuxtLink>         -->
      </template>
    </div>


    <NuxtLink :to="props.diary.link + '#weeks/' + props.week.id" class="cl">

      <GeneralWeekCalendar
        @click="useDiary().modalClick($event, props.diary.id, props.diary.link + '#weeks/' + props.week.id, props.diary)"
        :days="props.week.days"
        :faza="props.week.faza"
        :week-id="props.week.id"
      />

      <span class="clname" @click="useDiary().modalClick($event, props.diary.id, props.diary.link + '#weeks/' + props.week.id, props.diary)">
        <template v-if="props.week.days">
          Week {{ props.week.faza === -1 ? 'G' : props.week.days }}.         
        </template>
        {{ WeekFazaNameTr[props.week.faza] ? $t(WeekFazaNameTr[props.week.faza]) : '' }}
      </span>
    </NuxtLink>


  </div>

</template>

<script setup lang="ts">

import type { Diary, Week, WeekFaza } from '@/types/diary'
import type { Brand } from '@/types/brand'
import type { Product } from '@/types/product'
import type { User } from '@/types/user'
import type { DiaryEquip } from '@/types/diary'
import { WeekFazaNameTr } from '@/types/diary'

interface Props {
  diary: Diary;
  faza: WeekFaza;
  user: User,
  itemsSeed: Product[],
  matches: any,
  week: Week;
  days?: number;
  weekId: number | null;
}

const props = defineProps<Props>()
const elBrands = ref<HTMLElement | null>(null)
const showTooltip = ref(false)

const uniqBy = (arr: DiaryEquip[], key: string) => {
  return [...new Map(arr.map((item: DiaryEquip) => [item.item_brand?.id, item])).values()]
}

const brandSeedUniqLogos = computed(() => {
  return uniqBy(props.itemsSeed, 'item_brand.id').slice(0, 2);
});




</script>

<style scoped>
 
.head{
  display: grid;
  grid-template-areas: 
    "head_user head_user"
    "diary diary"
    "cl matches";
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  /* padding: 0.5rem 0; */
  margin-bottom: 0.5rem;
  align-items: center;
  width: calc(100% - 0px);
  
  gap: 0rem 1rem;
}
.head_user{
  display: grid;
  grid-template-areas: 
    "username brands";
  grid-template-columns:minmax(200px,1fr) auto;
  grid-area: head_user;
  width: 100%;
  gap: 0 1rem;
}
.username{
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  grid-area: username;
  flex-shrink: 0;
}

.username .nm{

  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
}
.matches a,
.matches{
  color: var(--un-text-color-gray-light);
}
.matches{  
  grid-area: matches;
  text-align: right;
}
.diary{
  margin-bottom: 0.3rem;
}
.lnk{
  display: block;
}
.lnk.av{
  flex-shrink: 0;
}
.ava{
  width: 25px;
  height: 25px;
  aspect-ratio: 1 / 1;
  object-fit: cover;  
  border-radius: 50px;
}
.date{
  font-size: 0.8rem;
  color: var(--un-text-color-gray-light);
  grid-area: date;
  white-space: nowrap;
}
.brands{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.3rem;
  color: var(--un-text-color-gray-light);  
  grid-area: brands;
  width: 100%;
}

.brands .nm {
  color: var(--un-text-color-gray-light);
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content;
}

.brands .brand_logo{
  width: 30px;
  vertical-align: bottom;
  flex-shrink: 0;
  aspect-ratio: 1 / 1;
  -o-object-fit: contain;
  object-fit: contain;
}
 
.diary{
  font-size: 1.2rem;
  font-weight: 600;
  grid-area: diary;
}
.cl{
  grid-area: cl;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: var(--un-text-color-gray-light);
  margin-top: -10px;
  margin-bottom: -10px;
}
.cl:deep(.cal){
  transform: scale(0.5);
  margin-left: -10px;
  margin-right: -5px;
  margin-top: -2px;
}

.tooltip-brands{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: left;
  align-items: flex-start;
}
.tooltip-brands .brand{
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  color: var(--un-text-color-gray-light);
  font-size: 0.9rem;
}
.tooltip-brands .brand img{
  width: 30px;
  vertical-align: bottom;
  flex-shrink: 0;
  aspect-ratio: 1 / 1;
  -o-object-fit: contain;
  object-fit: contain;
}
.tooltip-brands .brand .nm{}

@container pb (max-width: 600px) {
  .head{
    width: 100%;
    grid-template-areas: 
      "head_user"
      "diary"
      "matches";
    grid-template-columns: auto;
    position: relative;
  }
  .week{
    font-size: 1rem;
  }
  .matches{
    text-align: left;
  }
  .cl{
    position: absolute;
    right: inherit;
    left: 0;
    margin-top: 0;
    transform: none;
    bottom: -50px;
    z-index: 1;
  }
  .cl:deep(.cal){
    transform: scale(0.8);
  }
  .clname{
    display: none;
  }

  
}


</style>
